
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { gaEventTracker, EVENT_CATEGORIES, EVENT_ACTIONS, EVENT_LABELS } from '@/common/utils'

export default Vue.extend({
  name: 'Button3DModel',
  data(): {
    calcTimeInterval: number | null,
  } {
    return {
      calcTimeInterval: null
    }
  },
  computed: {
    ...mapGetters(['is3DModalOpen'])
  },
  created() {
    (document as any).addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.calcTimeInterval = window.setInterval(() => {
          if (this.is3DModalOpen)
            this.$store.commit('setIs3DModalOpen', false)
        }, 10000)
      } else {
        clearInterval(this.calcTimeInterval!)
      }
    })
  },
  methods: {
    open3DModel() {
      this.$store.commit('setIs3DModalOpen', true)
      const isMobileView = window.innerWidth <= 768
      const payload = {
        category: EVENT_CATEGORIES.PRODUCT_DETAIL,
        action: EVENT_ACTIONS.CLICK,
        label: isMobileView ? EVENT_LABELS.MOBILE_3D_MODEL : EVENT_LABELS.PC_3D_MODEL
      }

      gaEventTracker(payload)
    }
  }
})
